import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const MemoryApp = lazy(() => import('./MemoryApp'));

const MemoryAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/faithful',
      element: <MemoryApp />,
    },
  ],
};

export default MemoryAppConfig;
